import { useState } from 'react';
import { COLORS } from '../constants/theme';
import { useAuth } from '../contexts/AuthContext';
import { IntelHubTab } from '../components/intel/IntelHubTab';
import type { IntelReportDto } from '../types/intel';

/**
 * SF-171: Intel Hub only — the "Target Finder" tab moved out to its own route (`/world/targets`,
 * `pages/TargetFinder.tsx`), joining the World section's sibling row. This page keeps its own
 * route (`/intel`), unchanged, and renders `IntelHubTab` directly with no tab strip.
 * `IntelHubTab.tsx`'s own internals are untouched — out of scope for this spec.
 */
export function Intel() {
  const { worldId, provinceId } = useAuth();

  // Intel Hub state (kept at page level, matching the prior tab-persistence convention)
  const [hubReports, setHubReports] = useState<IntelReportDto[]>([]);
  const [hubLoaded, setHubLoaded] = useState(false);

  if (!worldId || !provinceId) {
    return <div style={{ color: COLORS.text.muted, padding: '24px' }}>Loading...</div>;
  }

  return (
    <IntelHubTab
      worldId={worldId}
      provinceId={provinceId}
      reports={hubReports}
      onReports={setHubReports}
      loaded={hubLoaded}
      onLoaded={setHubLoaded}
    />
  );
}
